<template>
    <div>
        <b-spinner v-if="loading" label="Loading..." />
        <div v-else class="row mt-2">
            <div class="col-4">
                <FlipBook
                    label="Student Edition"
                    type="student"
                    :unit_id="unit.id"
                    :book="student_edition"
                    :pdf_url="unit.student_edition_url"
                    :title="`Student Edition${unit.order_number ? ' ' + unit.order_number : ''}`"
                    :disabled="disabled"
                    @created="setBook"
                    @deleted="clearBook"
                />
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import FlipBook from '@/components/flipbooks/FlipBook'

export default {
    components: {FlipBook},
    data: () => ({
        student_edition: null,
        loading: false,
        timers: {},
    }),
    props: [
        'unit',
        'value',
        'disabled',
    ],
    watch: {
        value: {
            async handler(value) {
                if (value === true && !this.loading) {
                    await this.fetchFlipBooks()
                }
            },
        },
    },
    methods: {
        async fetchFlipBooks() {
            try {
                this.loading = true
                const response = await this.axios.get(`/api/units/flipbooks/${this.unit.id}`)
                this.student_edition = response.data.find((book) => book.book_type === 'student')

            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to retrieve FlipBooks: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            } finally {
                this.loading = false
            }
        },
        setBook(book) {
            switch (book.book_type) {
                case 'student':
                    this.student_edition = book
                    break
                default:
                    return
            }
            // poll for updates if we aren't already
            if (!this.timers[book.id]) {
                this.timers[book.id] = window.setInterval(this.checkForUpdatedBook, 5000, book.id)
            }
        },
        clearBook(book) {
            switch (book.book_type) {
                case 'student':
                    this.student_edition = null
                    break
                default:
                    return
            }
            // cancel any running timers
            if (this.timers[book.id]) {
                window.clearInterval(this.timers[book.id])
            }
        },
        async checkForUpdatedBook(bookId) {
            try {
                const response = await this.axios.get(`/api/flipbook/${bookId}`)
                const book = response.data

                this.setBook(book)
                if (book.status === 'completed' || book.status === 'failed') {
                    window.clearInterval(this.timers[bookId])
                    delete this.timers[bookId]
                }
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to fetch Flip Book: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }
        },
    },
    async mounted() {
        if (this.value === true && !this.loading) {
            await this.fetchFlipBooks()
        }
    },
}
</script>
